export default [
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {
          title: '天信人员管理系统'
        },
        children:[
          {
            path: '/',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '天信人员管理系统-控制台'
            },
          },
          {
            path: 'console',//控制台
            name: 'console',
            component: () => import('@/views/main/console/index'),
            meta: {
              title: '天信人员管理系统-控制台'
            },
          },
         
          {
            path: '/menu',//菜单管理
            name: 'menu',
            component: () => import('@/views/main/system/menu'),
            meta: {
              title: '天信人员管理系统-菜单管理'
            },
          },
          {
            path: '/person',//人员管理
            name: 'person',
            component: () => import('@/views/main/system/person'),
            meta: {
              title: '天信人员管理系统-人员管理'
            },
          },
          {
            path: '/role',//角色管理
            name: 'role',
            component: () => import('@/views/main/system/role'),
            meta: {
              title: '天信人员管理系统-角色管理'
            },
          },
          {
            path: '/permissionSetting',//人员权限管理
            name: 'permissionSetting',
            component: () => import('@/views/main/system/permissionSetting'),
            meta: {
              title: '天信人员管理系统-人员权限管理'
            },
          },
          {
            path: '/organization',//角色管理
            name: 'organization',
            component: () => import('@/views/main/system/organization'),
            meta: {
              title: '天信人员管理系统-角色管理'
            },
          },
          
         
         




          {
            path: '/contractManagement',//合同管理
            name: 'contractManagement',
            component: () => import('@/views/main/contractManagement/index'),
            meta: {
              title: '天信人员管理系统-合同管理'
            },
          },
          {
            path: '/contractOver',//合同管理
            name: 'contractOver',
            component: () => import('@/views/main/contractManagement/over'),
            meta: {
              title: '天信人员管理系统-过期合同管理'
            },
          },
          {
            path: '/contractManagementAdd',//添加合同
            name: 'contractManagementAdd',
            component: () => import('@/views/main/contractManagement/add'),
            meta: {
              title: '天信人员管理系统-添加合同'
            },
          },
          {
            path: '/contractManagementEdit',//添加合同
            name: 'contractManagementEdit',
            component: () => import('@/views/main/contractManagement/edit'),
            meta: {
              title: '天信人员管理系统-编辑合同'
            },
          },
          {
            path: '/contractManagementAudit',//合同审核
            name: 'contractManagementAudit',
            component: () => import('@/views/main/contractManagement/audit'),
            meta: {
              title: '天信人员管理系统-合同审核'
            },
          },
          {
            path: '/contractVerification',//合同审核
            name: 'contractVerification',
            component: () => import('@/views/main/contractVerification/index'),
            meta: {
              title: '天信人员管理系统-合同审核'
            },
          },
          {
            path: '/contractVerificationDetail',//合同审核详情
            name: 'contractVerificationDetail',
            component: () => import('@/views/main/contractVerification/detail'),
            meta: {
              title: '天信人员管理系统-合同审核详情'
            },
          },


          {
            path: '/employeeManagement',//员工管理
            name: 'employeeManagement',
            component: () => import('@/views/main/employeeManagement/index'),
            meta: {
              title: '天信人员管理系统-员工管理'
            },
          },
          {
            path: '/employeeManagementAdd',//员工管理
            name: 'employeeManagementAdd',
            component: () => import('@/views/main/employeeManagement/add'),
            meta: {
              title: '天信人员管理系统-员工管理-新增'
            },
          },
          {
            path: '/employeeManagementEdit',//员工管理
            name: 'employeeManagementEdit',
            component: () => import('@/views/main/employeeManagement/edit'),
            meta: {
              title: '天信人员管理系统-员工管理-编辑'
            },
          },

          {
            path: '/companyManagement',//分公司/机构管理
            name: 'companyManagement',
            component: () => import('@/views/main/organizationManagement/companyManagement/index'),
            meta: {
              title: '天信人员管理系统-分公司/机构管理'
            },
          },
          {
            path: '/businessDivisionManagement',//事业部管理
            name: 'businessDivisionManagement',
            component: () => import('@/views/main/organizationManagement/businessDivisionManagement/index'),
            meta: {
              title: '天信人员管理系统-事业部管理'
            },
          },
          {
            path: '/roleManagement',//角色管理
            name: 'roleManagement',
            component: () => import('@/views/main/baseSetting/roleManagement/index'),
            meta: {
              title: '天信人员管理系统-角色管理'
            },
          },
          {
            path: '/roleLimits',//角色菜单管理
            name: 'roleLimits',
            component: () => import('@/views/main/baseSetting/roleLimits/index'),
            meta: {
              title: '天信人员管理系统-角色菜单管理'
            },
          },
          {
            path: '/accountManagement',//账号管理
            name: 'accountManagement',
            component: () => import('@/views/main/baseSetting/accountManagement/account'),
            meta: {
              title: '天信人员管理系统-账号管理'
            },
          },
          {
            path: '/menuManagement',//菜单管理
            name: 'menuManagement',
            component: () => import('@/views/main/baseSetting/menuManagement/index'),
            meta: {
              title: '天信人员管理系统-菜单管理'
            },
          },
          {
            path: '/dataManagement',//数据统计
            name: 'dataManagement',
            component: () => import('@/views/main/dataManagement/index'),
            meta: {
              title: '天信人员管理系统-数据统计'
            },
          },

          {
            path: '/socialSecurity',//社保管理
            name: 'socialSecurity',
            component: () => import('@/views/main/socialSecurity/index'),
            meta: {
              title: '天信人员管理系统-社保管理'
            },
          },
          {
            path: '/accumulationFund',//公积金管理
            name: 'accumulationFund',
            component: () => import('@/views/main/accumulationFund/index'),
            meta: {
              title: '天信人员管理系统-公积金管理'
            },
          },
          {
            path: '/sealVerification',//用印申请
            name: 'sealVerification',
            component: () => import('@/views/main/sealVerification/index'),
            meta: {
              title: '天信人员管理系统-用印申请'
            },
          },
          {
            path: '/sealVerificationAudits',//用印申请一审
            name: 'sealVerificationAudits',
            component: () => import('@/views/main/sealVerification/audits'),
            meta: {
              title: '天信人员管理系统-用印申请一审'
            },
          },
          {
            path: '/sealVerificationAudite',//用印申请终审
            name: 'sealVerificationAudite',
            component: () => import('@/views/main/sealVerification/audite'),
            meta: {
              title: '天信人员管理系统-用印申请终审'
            },
          },

          {
            path: '/carManage',//车辆管理
            name: 'carManage',
            component: () => import('@/views/main/corporateAssets/carManage'),
            meta: {
              title: '天信人员管理系统-车辆管理'
            },
          },
          {
            path: '/lease',//租赁到期
            name: 'lease',
            component: () => import('@/views/main/corporateAssets/lease'),
            meta: {
              title: '天信人员管理系统-租赁到期'
            },
          },
          {
            path: '/insurance',//保险到期
            name: 'insurance',
            component: () => import('@/views/main/corporateAssets/insurance'),
            meta: {
              title: '天信人员管理系统-保险到期'
            },
          },
          {
            path: '/costManage',//费用管理
            name: 'costManage',
            component: () => import('@/views/main/corporateAssets/costManage'),
            meta: {
              title: '天信人员管理系统-费用管理'
            },
          },
          {
            path: '/AS',//年检到期
            name: 'AS',
            component: () => import('@/views/main/corporateAssets/AS'),
            meta: {
              title: '天信人员管理系统-年检到期'
            },
          },
          {
            path: '/breakRulesAndRegulations',//违章处理
            name: 'breakRulesAndRegulations',
            component: () => import('@/views/main/corporateAssets/breakRulesAndRegulations'),
            meta: {
              title: '天信人员管理系统-违章处理'
            },
          },
          {
            path: '/carDetail',//违章处理
            name: 'carDetail',
            component: () => import('@/views/main/corporateAssets/detail'),
            meta: {
              title: '天信人员管理系统-详情'
            },
          },
          {
            path: '/pdf',//查看pdf
            name: 'pdf',
            component: () => import('@/views/main/corporateAssets/pdf'),
            meta: {
              title: '天信人员管理系统-查看pdf'
            },
          },
          {
            path: '/rewards_punishment',//奖励处罚
            name: 'rewards_punishment',
            component: () => import('@/views/main/rewards_punishment/index'),
            meta: {
              title: '天信人员管理系统-奖励处罚'
            },
          },
          {
            path: '/trainingRecord',//培训记录
            name: 'trainingRecord',
            component: () => import('@/views/main/trainingRecord/index'),
            meta: {
              title: '天信人员管理系统-培训记录'
            },
          },
        ]
      },

]